import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  ScrollView,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import { AntDesign } from "@expo/vector-icons";
import moment from "moment";
import { apiservice } from "../../service/service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
const { width, height } = Dimensions.get("window");

export default function report({ navigation }) {
  const token = useRecoilValue(tokenState);
  const [version, setVersion] = useState("0");

  useEffect(() => {
    apicall();
  }, []);

  async function apicall() {
    const res = await apiservice({
      path: "/version",
    });

    if (res?.status == 200) {
      setVersion(res?.data);
    }
  }

  async function save() {
    const res = await apiservice({
      path: "/versions?title=" + version,
      method: "get"
    });
    if (res?.status == 200) {
      // setReport(res?.data?.data);
    }
  }

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <Text style={styles.textfree}>Version</Text>
          <View
            style={[
              styles.viewfree,
              { backgroundColor: "#FCC81D50" },
              { padding: 5 },
            ]}
          >
            <View
              style={{
                width: width * 0.2,
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.textadd}>Version</Text>
              <View style={{ flexDirection: "row" }}>
                <TextInput
                  style={styles.touch1}
                  onChangeText={setVersion}
                  value={version}
                />
              </View>
              <TouchableOpacity
                onPress={save}
                style={{
                  width: 60,
                  height: 30,
                  backgroundColor: "#4B4B48",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <AntDesign
                  name="save"
                  size={24}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.845,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.825,
    flexDirection: "row",
    marginTop: 10,
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
  },
  touch: {
    width: 200,
    height: 40,
    justifyContent: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#8898AA",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#172B4D",
    alignSelf: "center",
  },
  touch1: {
    width: width * 0.1,
    height: 30,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    borderRadius: 5,
    paddingLeft: 20,
    backgroundColor: "#fff",
  },
  botton1: {
    alignSelf: "flex-end",
    padding: 5,
    marginLeft: -30,
  },
});
